export default __webpack_public_path__ + "static/media/icon_sid.42f76872.webp";